import { c as _c } from "react/compiler-runtime";
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import i18n from '@/src/i18n';
import { sendAnalyticsData } from '@/src/utils/analytics';
export function DropDownMenu(t0) {
  const $ = _c(22);
  const {
    linkName,
    sunMenu,
    closeMenu
  } = t0;
  const path = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      query: "(max-width: 1023px)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isTabletOrMobile = useMediaQuery(t1);
  const timeoutRef = useRef(null);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setMounted(true);
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setIsOpen(true);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleMouseEnter = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      timeoutRef.current = setTimeout(() => setIsOpen(false), 100);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleMouseLeave = t5;
  if (mounted && isTabletOrMobile) {
    let t6;
    if ($[5] !== closeMenu || $[6] !== linkName || $[7] !== path || $[8] !== sunMenu) {
      t6 = <div><Disclosure>{t7 => {
            const {
              open
            } = t7;
            return <div><DisclosureButton className="hover:no-scrollbar flex  w-full items-center px-3 py-2.5 text-left"><span className="text-[16px] font-normal text-[#404040]">{linkName}</span><ChevronDownIcon className={`ml-1 mt-1 size-4 ${open ? "rotate-180" : ""}`} /></DisclosureButton><DisclosurePanel className="no-scrollbar overflow-y-auto px-4 pb-4 pt-2 text-sm text-gray-500">{sunMenu.map((item, idx) => <Link href={item.link} key={idx} onClick={() => {
                  window.location.href = item.link;
                  if (closeMenu) {
                    closeMenu();
                  }
                }}><span className={`${idx !== 0 && "mt-1"} block rounded-md bg-white px-3 py-[6px] text-base font-normal hover:cursor-pointer hover:bg-[#F6F7F8] ${path === item.link ? "text-[#318AE5]" : "text-[#464E5F]"}`}>{i18n.t(item.name)}</span></Link>)}</DisclosurePanel></div>;
          }}</Disclosure></div>;
      $[5] = closeMenu;
      $[6] = linkName;
      $[7] = path;
      $[8] = sunMenu;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  let t6;
  if ($[10] !== linkName) {
    t6 = <span className="text-[16px] font-normal text-[#404040]">{linkName}</span>;
    $[10] = linkName;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChevronDownIcon className="stroke-3 size-3" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <MenuButton className="flex items-center justify-center space-x-2 rounded-md px-3 py-2 data-[hover]:bg-[#F6F7F8] data-[open]:bg-[#F6F7F8]">{t6}{t7}</MenuButton>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isOpen || $[16] !== path || $[17] !== sunMenu) {
    t9 = isOpen && <MenuItems static={true} className="absolute z-[100000] mt-2 w-[189px] rounded-lg border border-[#ECEEF0] bg-white p-2 shadow-[0px_0px_12px_0px_rgba(0,0,0,0.06)]">{sunMenu.map((item_0, idx_0) => <MenuItem key={idx_0}><Link href={item_0.link} onClick={() => {
          setIsOpen(false);
          sendAnalyticsData(`HEADER_MENU_${item_0.name.replace(" ", "_").toUpperCase()}_CLICKED`, {
            tab: item_0.name
          });
        }}><span className={`${idx_0 !== 0 && "mt-1"} block rounded-md bg-white px-3 py-[6px] text-base font-normal hover:cursor-pointer hover:bg-[#F6F7F8] ${path === item_0.link ? "text-[#318AE5]" : "text-[#464E5F]"}`}>{i18n.t(item_0.name)}</span></Link></MenuItem>)}</MenuItems>;
    $[15] = isOpen;
    $[16] = path;
    $[17] = sunMenu;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <Menu as="div" className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>{t8}{t9}</Menu>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}